<template>
  <v-card max-width="400" width="400" elevation="2">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "AmplifyCard"
}
</script>

<style scoped>
:deep(.v-field--variant-outlined .v-field__outline) {
  color: rgb(var(--v-theme-primary));
}
</style>